import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-signup-professional',
  templateUrl: './signup-professional.component.html',
  styleUrls: ['./signup-professional.component.scss'],
})
export class SignupProfessionalComponent implements OnInit {
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {

    const target = event.target as HTMLElement;

    if (!target.closest('.custom-dropdown')) {
      this.showDropdown = '';
    }

  }
  educations: any[] = [];
  highests: any[] = [];
  employments: any[] = [];
  occupations: any[] = [];
  incomes: any[] = [];
  citys: any[] = [];
  districts: any[] = [];
  states: any[] = [];
  countrys: any[] = [];
  signupprofessional!: FormGroup;
  showDropdown: string = '';

  selectedEducation = '';
  selectedHighest = '';
  selectedEmployment = '';
  selectedOccupation = '';
  selectedIncome = '';
  selectedCountry = '';
  selectedState = '';
  selectedDistrict = '';
  selectedCity = '';
  additionalIncomeSources = ['Rental Income', 'Agriculture', 'Business', 'Investments', 'Freelancing', 'Other (Specify / Type Custom)'];
  selectedAadhaarFile: File | null = null;



  filteredEducations: any[] = [];
  filteredHighests: any[] = [];
  filteredEmployments: any[] = [];
  filteredOccupations: any[] = [];
  filteredIncomes: any[] = [];
  filteredCountrys: any[] = [];
  filteredStates: any[] = [];
  filteredDistricts: any[] = [];
  filteredCitys: any[] = [];
  constructor(
    private apiService: ApiServiceService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {
    this.signupprofessional = this.formBuilder.group({
      education: ['', Validators.required],
      education_detail: [''],
      highest: ['', Validators.required],
      employment: ['', Validators.required],
      occupation: ['', Validators.required],
      occupation_detail: [''],
      income: ['', Validators.required],
      city: ['', Validators.required],
      district: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      pincode: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      familyType: ['', Validators.required],
      familyStatus: ['', Validators.required],
      fatherJob: [''],
      motherJob: [''],
      brothers: [0, Validators.required],
      sisters: [0, Validators.required],
      additional_income_source: [''],
      additional_annual_income: ['', [Validators.pattern('^[1-9][0-9]*$')]]
    });
  }

  ngOnInit(): void {
    const profileId = localStorage.getItem('profileId');
    const sessionToken = localStorage.getItem('sessionToken');
    if (!profileId || !sessionToken) {
      this.router.navigate(['/signup-basic']);
      return;
    }

    this.signupprofessional.get('additional_income_source')?.valueChanges.subscribe(val => {
      const annualCtrl = this.signupprofessional.get('additional_annual_income');
      if (val && val.trim() !== '') {
        annualCtrl?.setValidators([Validators.required, Validators.pattern('^[1-9][0-9]*$')]);
      } else {
        annualCtrl?.setValidators([Validators.pattern('^[1-9][0-9]*$')]);
      }
      annualCtrl?.updateValueAndValidity({ emitEvent: false });
    });

    forkJoin([
      this.apiService.getEducation(),
      this.apiService.getHigherEducation(),
      this.apiService.getEmploymentType(),
      this.apiService.getOccupation(),
      this.apiService.getIncome(),
      this.apiService.getCity(),
      this.apiService.getDistrict(),
      this.apiService.getState(),
      this.apiService.getCountry(),
    ]).subscribe({
      next: ([
        educationsResponse,
        highestsResponse,
        employmentsResponse,
        occupationsResponse,
        incomesResponse,
        citysResponse,
        districtsResponse,
        statesResponse,
        countrysResponse,
      ]) => {
        this.educations = educationsResponse.data;
        this.highests = highestsResponse.data;
        this.employments = employmentsResponse.data;
        this.occupations = occupationsResponse.data;
        this.incomes = incomesResponse.data;
        this.citys = citysResponse.data;
        this.districts = districtsResponse.data;
        this.states = statesResponse.data;
        this.countrys = countrysResponse.data;
        console.log("COUNTRY", countrysResponse.data);
        console.log("STATE", statesResponse.data);
        console.log("DISTRICT", districtsResponse.data);
        console.log("CITY", citysResponse.data);
        this.filteredEducations = this.educations;
        this.filteredHighests = this.highests;
        this.filteredEmployments = this.employments;
        this.filteredOccupations = this.occupations;
        this.filteredIncomes = this.incomes;
        this.filteredCountrys = this.countrys;
        this.filteredStates = this.states;
        this.filteredDistricts = this.districts;
        this.filteredCitys = this.citys;
      },
      error: (error) => {
        console.error(
          'Error fetching professional and location master details:',
          error,
        );
      },
    });
  }
  openDropdown(type: string) {


    if (type === 'state' && !this.signupprofessional.value.country) {

      Swal.fire(
        'Select Country',
        'First select country',
        'warning'
      );

      return;
    }



    if (type === 'district' && !this.signupprofessional.value.state) {

      Swal.fire(
        'Select State',
        'First select state',
        'warning'
      );

      return;
    }



    if (type === 'city' && !this.signupprofessional.value.district) {

      Swal.fire(
        'Select District',
        'First select district',
        'warning'
      );

      return;
    }



    this.showDropdown = type;
    if (type === 'state') {
      console.log("STATE DROPDOWN OPENED");
      console.log("STATE COUNT:", this.filteredStates.length);
      console.log("STATES:", this.filteredStates);
    }
    if (type === 'country') {
      this.filteredCountrys = this.countrys;
    }


    if (type === 'district') {
      console.log("DISTRICT OPEN");
      console.log("DISTRICT LIST", this.filteredDistricts);
    }
    if (type === 'city') {

      console.log("CITY DROPDOWN OPEN");
      console.log("CITY LIST:", this.filteredCitys);

    }

  }

  filterDropdown(event: any, type: string) {
    const value = event.target.value.toLowerCase();

    if (type === 'education') {
      this.filteredEducations = this.educations.filter((x) =>
        x.education_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'highest') {
      this.filteredHighests = this.highests.filter((x) =>
        x.highereducation_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'employment') {
      this.filteredEmployments = this.employments.filter((x) =>
        x.employment_type_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'occupation') {
      this.filteredOccupations = this.occupations.filter((x) =>
        x.occupation_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'income') {
      this.filteredIncomes = this.incomes.filter((x) =>
        x.income_nme.toLowerCase().includes(value),
      );
    }

    if (type === 'country') {
      this.filteredCountrys = this.countrys.filter((x) =>
        x.name_0.toLowerCase().includes(value),
      );
    }
    console.log("SEARCH TYPE:", type);
    console.log("SEARCH VALUE:", value);
    console.log("COUNTRY VALUE:", this.signupprofessional.value.country);
    console.log("STATE SAMPLE:", this.states[0]);
    const selectedCountry = this.countrys.find(
      c => c._id === this.signupprofessional.value.country
    );


    this.filteredStates = this.states.filter(
      x =>
        x.country_id === selectedCountry?.country_id &&
        x.name_1.toLowerCase().includes(value)
    );


    console.log("STATE SEARCH RESULT", this.filteredStates);

    if (type === 'district') {

      const stateId = this.signupprofessional.value.state;

      const selectedState = this.states.find(
        x => x._id === stateId
      );

      this.filteredDistricts = this.districts.filter(
        x =>
          x.state_id === selectedState?.state_id &&
          x.name_2.toLowerCase().includes(value)
      );

      console.log("DISTRICT SEARCH RESULT", this.filteredDistricts);

    }

    if (type === 'city') {

      const districtId = this.signupprofessional.value.district;

      const selectedDistrict = this.districts.find(
        x => x._id === districtId
      );


      this.filteredCitys = this.citys.filter(
        x =>
          x.id_2 === selectedDistrict?.id_2 &&
          x.city_nme.toLowerCase().includes(value)
      );


      console.log("CITY SEARCH RESULT", this.filteredCitys);

    }
  }

  selectItem(item: any, type: string) {
    if (type === 'education') {
      this.selectedEducation = item.education_nme;
      this.signupprofessional.patchValue({
        education: item._id,
      });
    }

    if (type === 'highest') {
      this.selectedHighest = item.highereducation_nme;
      this.signupprofessional.patchValue({
        highest: item._id,
      });
    }

    if (type === 'employment') {
      this.selectedEmployment = item.employment_type_nme;
      this.signupprofessional.patchValue({
        employment: item._id,
      });
    }

    if (type === 'occupation') {
      this.selectedOccupation = item.occupation_nme;
      this.signupprofessional.patchValue({
        occupation: item._id,
      });
    }

    if (type === 'income') {
      this.selectedIncome = item.income_nme;
      this.signupprofessional.patchValue({
        income: item._id,
      });
    }
    if (type === 'country') {
      console.log("Selected Country:", item);
      console.log("Country ID:", item.country_id);
      console.log("States first:", this.states[0]);

      this.selectedCountry = item.name_0;

      this.signupprofessional.patchValue({
        country: item._id,
        state: '',
        district: '',
        city: ''
      });


      this.selectedState = '';
      this.selectedDistrict = '';
      this.selectedCity = '';


      this.filteredStates = this.states.filter(
        (state) => state.country_id === item.country_id

      );
      console.log("FILTERED STATES", this.filteredStates);
      console.log("Selected Country ID:", item.country_id);
      console.log("Filtered State Count:", this.filteredStates.length);
      console.log("First State:", this.filteredStates[0]);
      this.filteredDistricts = [];
      this.filteredCitys = [];
    }


    if (type === 'state') {
      console.log("SELECTED STATE", item);
      console.log("STATE ID", item.state_id);
      console.log("DISTRICT SAMPLE", this.districts[0]);

      this.selectedState = item.name_1;

      this.signupprofessional.patchValue({
        state: item._id,
        district: '',
        city: ''
      });


      this.selectedDistrict = '';
      this.selectedCity = '';


      this.filteredDistricts = this.districts.filter(
        (district) => district.state_id === item.state_id
      );
      console.log("SELECTED STATE ID", item.state_id);

      console.log(
        "DISTRICT COUNT",
        this.districts.filter(
          district => district.state_id === item.state_id
        ).length
      );
      console.log("FILTERED DISTRICTS", this.filteredDistricts);

      this.filteredCitys = [];
    }


    if (type === 'district') {

      console.log("SELECTED DISTRICT OBJECT:", item);

      console.log("SELECTED DISTRICT id_2:", item.id_2);

      console.log(
        "ALL CITY id_2 SAMPLE:",
        this.citys.map(city => city.id_2).slice(0, 20)
      );


      this.selectedDistrict = item.name_2;


      this.signupprofessional.patchValue({
        district: item._id,
        city: ''
      });


      this.selectedCity = '';


      this.filteredCitys = this.citys.filter(
        city => city.id_2 === item.id_2
      );


      console.log(
        "FILTERED CITY RESULT:",
        this.filteredCitys
      );

    }


    if (type === 'city') {

      this.selectedCity = item.city_nme;

      this.signupprofessional.patchValue({
        city: item._id
      });

    }
    this.showDropdown = '';
  }

  isCustomAddIncome(val: string | null | undefined): boolean {
    if (!val) return false;
    const standard = ['Rental Income', 'Agriculture', 'Business', 'Investments', 'Freelancing'];
    return !standard.includes(val);
  }

  onCustomAddIncomeInput(event: any): void {
    const customVal = event.target.value;
    this.signupprofessional.patchValue({
      additional_income_source: customVal || 'Other (Specify / Type Custom)'
    }, { emitEvent: true });
  }

  selectAddIncomeSource(src: string): void {
    if (src === 'Other (Specify / Type Custom)' || src === 'Other') {
      this.signupprofessional.patchValue({ additional_income_source: 'Other (Specify / Type Custom)' });
    } else {
      this.signupprofessional.patchValue({ additional_income_source: src });
    }
    if (!src) {
      this.signupprofessional.patchValue({ additional_annual_income: '' });
    }
    this.showDropdown = '';
  }

  onAadhaarSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      if (!allowedExtensions.includes(fileExtension || '')) {
        Swal.fire({
          title: 'Invalid File Format',
          text: 'Only JPG, JPEG, PNG, and PDF files are allowed.',
          icon: 'error',
          confirmButtonColor: '#a73453',
        });
        event.target.value = '';
        this.selectedAadhaarFile = null;
        return;
      }

      this.selectedAadhaarFile = file;
    } else {
      this.selectedAadhaarFile = null;
    }
  }

  completeRegistrationAndRedirect(): void {
    localStorage.removeItem('profileId');
    localStorage.removeItem('sessionToken');

    Swal.fire({
      title: 'Registration Complete!',
      text: 'Your profile has been created successfully. Please log in.',
      icon: 'success',
      confirmButtonColor: '#a73453',
    }).then(() => {
      this.router.navigate(['/login']);
    });
  }

  onSubmit() {
    if (this.signupprofessional.valid) {
      const formData = this.signupprofessional.value;
      const profileId = localStorage.getItem('profileId');
      const sessionToken = localStorage.getItem('sessionToken');

      if (!profileId || !sessionToken) {
        Swal.fire('Error', 'Session expired. Please sign up again.', 'error');
        this.router.navigate(['/signup-basic']);
        return;
      }

      const requestData = {
        action: 'professional',
        type: 'signup',
        profileId: profileId,
        data: {
          professional_info: {
            education_id: formData.education,
            education_detail: formData.education_detail || '',
            higher_education_id: formData.highest,
            employmentype_id: formData.employment,
            occupation_id: formData.occupation,
            occupation_detail: formData.occupation_detail || '',
            income_id: formData.income,
            work_city_id: formData.city,
            work_dist_id: formData.district,
            work_state_id: formData.state,
            work_country_id: formData.country,
            work_zipcode: formData.pincode,
            additional_income_source: formData.additional_income_source || '',
            additional_annual_income: formData.additional_annual_income ? Number(formData.additional_annual_income) : null
          },
          residing_location: {
            city_id: formData.city,
            dist_id: formData.district,
            state_id: formData.state,
            country_id: formData.country,
            zipcode: formData.pincode
          },
          family_info: {
            family_type: formData.familyType,
            family_status: formData.familyStatus,
            father_occupation_id: formData.fatherJob,
            mother_occupation_id: formData.motherJob,
            no_of_brothers: formData.brothers,
            no_of_sisters: formData.sisters
          }
        }
      };

      this.apiService
        .submitProfessionalData(requestData, sessionToken)
        .subscribe({
          next: (response) => {
            if (response.status === 'success') {
              if (this.selectedAadhaarFile) {
                const uploadData = new FormData();
                uploadData.append('aadhaar', this.selectedAadhaarFile);
                this.apiService.uploadAadhaar(profileId, uploadData).subscribe({
                  next: () => {
                    this.completeRegistrationAndRedirect();
                  },
                  error: (uploadError) => {
                    console.error('Aadhaar upload error:', uploadError);
                    this.completeRegistrationAndRedirect();
                  }
                });
              } else {
                this.completeRegistrationAndRedirect();
              }
            } else {
              Swal.fire({
                title: 'Error',
                text:
                  response.message || 'Failed to submit professional details.',
                icon: 'error',
                confirmButtonColor: '#a73453',
              });
            }
          },
          error: (error) => {
            console.error('Submit professional details error:', error);
            Swal.fire({
              title: 'Error',
              text: 'An error occurred. Please try again.',
              icon: 'error',
              confirmButtonColor: '#a73453',
            });
          },
        });
    } else {
      this.signupprofessional.markAllAsTouched();
      Swal.fire({
        title: 'Form Invalid',
        text: 'Please select all education and work locations.',
        icon: 'warning',
        confirmButtonColor: '#a73453',
      });
    }
  }
}
